const styles = () => ({
    container: {
        width: '100%',
        height: '100%',
        minHeight: '768px',
        overflow: 'hidden',
        backgroundSize: 'cover',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    boxLogin: {
        maxWidth: '420px',
        boxShadow: '0px 15px 45px rgba(0, 0, 0, .2)',
        borderRadius: '30px',
    },
    content: {
        zIndex: 998,
        position: 'relative',
        padding: '1em',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
    },
    backButton: {
        color: '#3372b8',
        position: 'absolute',
        top: 0,
        left: 0,
        padding: '5px',
        fontSize: '1rem',
        marginTop: '.5em',
    },
    logo: {
        width: '15em',
    },
    swipeViews: {
        maxWidth: 290,
    },
});

export default styles;
